<template>
  <!-- Advertisement List -->
  <div
    class="flex flex-wrap"
  >
    <div
      class=" flex items-center justify-between h-full overflow-x-hidden scrollbar-hide w-full flex-col"
      @keydown="()=>{ }"
    >
      <div
        class="w-full flex flex-col items-center relative"
        tabindex="0"
        :style="!showAdvertisementDetailsDrawer && (grabbing ? 'cursor: grabbing;' : 'cursor: grab;')"
        @mouseleave="() => { grabbing = false }"
        @keydown="handleArrowNavigation"
        @wheel="handleScrollChart"
      >
        <g-gantt-chart
          v-if="advertisements.length"
          class="relative"
          hide-timeaxis
          :chart-start="myChartStart"
          :chart-end="myChartEnd"
        >
          <g-gantt-row
            v-for="(ad, index) in advertisements"
            :key="ad.id"
            :bars="[
              {
                myStart: `${formatAdvertisementTime(ad.startedRunning)}`,
                myEnd: `${formatAdvertisementTime((ad.last_checked?._seconds ? ad.last_checked?._seconds * 1000 : new Date()))}`,
              }
            ]"
            bar-start="myStart"
            bar-end="myEnd"
            class=" hover:bg-background-normal group"
            @mousedown.prevent="handleMouseDown"
            @mouseup.prevent="() => handleMouseUp($event, ad)"
            @mousemove.prevent="handleDragChart"
          >
            <template #bar-label>
              <div
                :ref="`gantt-label-${ad.id}`"
                class="w-full h-full flex items-center group rounded-md relative truncate"
                :class="ad.live ? 'green-background bg-primary-green-10 border border-primary-green-100 border-b-0 border-opacity-10' : 'gray-background bg-neutral-25 border border-border-hover border-b-0'"
                @mousedown.prevent="handleMouseDown"
                @mouseup.prevent="() => handleMouseUp($event, ad)"
                @mousemove.prevent="handleDragChart"
              >
                <BaseText
                  type="body"
                  size="sm"
                  class="text-text-loud px-3 gantt-row-text"
                  :style="advertisementRightValues[index] !== '20%' && `left: ${advertisementRightValues[index]}px`"
                  :class="advertisementRightValues[index] !== '20%' ? 'absolute' : 'unset truncate'"
                >
                  {{
                    `${formatRunningDuration( ad?.startedRunning,
                  ad?.lastChecked || ad?.last_checked
                    )} ${
                      formatRunningDuration(
                    ad?.startedRunning,
                    ad?.lastChecked ||
                      ad?.last_checked
                      ) > 1
                        ? "Days"
                        : "Day"
                    }`
                  }}
                </BaseText>
              </div>
            </template>
            <template #label>
              <div
                class="flex items-center pl-2 w-full whitespace-nowrap bg-white h-full group cursor-pointer transition-all duration-75 border-t border-r border-border-normal gap-1 flex-shrink-0 relative group-hover:bg-background-normal"
              >
                <img
                  :src="ad.image || ad.thumbnail || (ad.cards?.length && ad?.cards[0]?.thumbnail) ||( ad.cards?.length && ad?.cards[0]?.image) || ''"
                  alt=""
                  class="h-7 w-7 rounded-md"
                >
                <svg
                  v-if="ad.image"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  class="h-5 w-5 rounded-md"
                >
                  <path
                    d="M3.00247 10.1587C2.81395 10.3361 2.80496 10.6327 2.98239 10.8213C3.15982 11.0098 3.45648 11.0188 3.645 10.8413L3.00247 10.1587ZM5.53844 8.41557L5.8597 8.75691L5.53844 8.41557ZM6.40873 8.42875L6.07728 8.76021H6.07728L6.40873 8.42875ZM8.47998 10.5L8.14852 10.8315C8.23643 10.9194 8.35566 10.9688 8.47998 10.9688C8.6043 10.9688 8.72353 10.9194 8.81144 10.8315L8.47998 10.5ZM9.28804 9.69194L8.95658 9.36048L8.95658 9.36049L9.28804 9.69194ZM10.1719 9.69194L9.84047 10.0234L10.1719 9.69194ZM12.836 13.019C13.0191 13.202 13.3159 13.202 13.4989 13.019C13.682 12.8359 13.682 12.5391 13.4989 12.356L12.836 13.019ZM4.57373 3.3125L12.3862 3.3125V2.375L4.57373 2.375V3.3125ZM13.1675 4.09375L13.1675 11.9062H14.105L14.105 4.09375H13.1675ZM12.3862 12.6875L4.57373 12.6875V13.625L12.3862 13.625V12.6875ZM3.79248 11.9062L3.79248 4.09375H2.85498L2.85498 11.9062H3.79248ZM4.57373 12.6875C4.14226 12.6875 3.79248 12.3377 3.79248 11.9062H2.85498C2.85498 12.8555 3.62449 13.625 4.57373 13.625V12.6875ZM13.1675 11.9062C13.1675 12.3377 12.8177 12.6875 12.3862 12.6875V13.625C13.3355 13.625 14.105 12.8555 14.105 11.9062H13.1675ZM12.3862 3.3125C12.8177 3.3125 13.1675 3.66228 13.1675 4.09375H14.105C14.105 3.14451 13.3355 2.375 12.3862 2.375V3.3125ZM4.57373 2.375C3.62449 2.375 2.85498 3.14451 2.85498 4.09375H3.79248C3.79248 3.66228 4.14226 3.3125 4.57373 3.3125V2.375ZM3.645 10.8413L5.8597 8.75691L5.21717 8.07423L3.00247 10.1587L3.645 10.8413ZM6.07728 8.76021L8.14852 10.8315L8.81144 10.1685L6.74019 8.0973L6.07728 8.76021ZM8.81144 10.8315L9.6195 10.0234L8.95658 9.36049L8.14852 10.1685L8.81144 10.8315ZM9.84047 10.0234L12.836 13.019L13.4989 12.356L10.5034 9.36049L9.84047 10.0234ZM9.61949 10.0234C9.68051 9.96238 9.77945 9.96238 9.84047 10.0234L10.5034 9.36049C10.0762 8.93335 9.38372 8.93335 8.95658 9.36048L9.61949 10.0234ZM5.8597 8.75691C5.9212 8.69903 6.01756 8.70049 6.07728 8.76021L6.74019 8.0973C6.32217 7.67928 5.64766 7.66906 5.21717 8.07423L5.8597 8.75691ZM10.355 6.125C10.355 6.38388 10.1451 6.59375 9.88623 6.59375V7.53125C10.6629 7.53125 11.2925 6.90165 11.2925 6.125H10.355ZM9.88623 6.59375C9.62735 6.59375 9.41748 6.38388 9.41748 6.125H8.47998C8.47998 6.90165 9.10958 7.53125 9.88623 7.53125V6.59375ZM9.41748 6.125C9.41748 5.86612 9.62735 5.65625 9.88623 5.65625V4.71875C9.10958 4.71875 8.47998 5.34835 8.47998 6.125H9.41748ZM9.88623 5.65625C10.1451 5.65625 10.355 5.86612 10.355 6.125H11.2925C11.2925 5.34835 10.6629 4.71875 9.88623 4.71875V5.65625Z"
                    fill="#5E6678"
                  />
                </svg>
                <svg
                  v-else-if="ad.video"
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  class="h-5 w-5 rounded-md"
                >
                  <path
                    d="M3.25342 7.99995H5.6784M3.25342 7.99995L3.25342 5.42185M3.25342 7.99995L3.25342 10.578M5.6784 7.99995L10.8315 7.99995M5.6784 7.99995L5.6784 10.578M5.6784 7.99995L5.6784 5.42185M10.8315 7.99995L13.2565 7.99995M10.8315 7.99995V10.8645M10.8315 7.99995V5.42185M13.2565 7.99995V5.42185M13.2565 7.99995L13.2565 10.8645M10.8315 13.1561H12.044C12.7136 13.1561 13.2565 12.5965 13.2565 11.9062V10.8645M10.8315 13.1561L10.8315 10.8645M10.8315 13.1561L5.6784 13.1561M10.8315 2.84375H12.044C12.7136 2.84375 13.2565 3.40339 13.2565 4.09374V5.42185M10.8315 2.84375V5.42185M10.8315 2.84375L5.6784 2.84375M10.8315 5.42185H13.2565M10.8315 10.8645H13.2565M5.6784 13.1561H4.46591C3.79627 13.1561 3.25342 12.5965 3.25342 11.9062V10.578M5.6784 13.1561V10.578M5.6784 2.84375L4.46591 2.84375C3.79627 2.84375 3.25342 3.40339 3.25342 4.09374L3.25342 5.42185M5.6784 2.84375V5.42185M3.25342 5.42185H5.6784M3.25342 10.578H5.6784"
                    stroke="#5E6678"
                    stroke-width="0.937491"
                    stroke-linecap="square"
                    stroke-linejoin="round"
                  />
                </svg>
                <svg
                  v-else
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  class="h-5 w-5 rounded-md"
                >
                  <path
                    d="M6.41781 15V4.99998M6.41781 15C6.41781 15.9205 7.164 16.6666 8.08447 16.6666H13.0845C14.0049 16.6666 14.7511 15.9205 14.7511 15M6.41781 15H4.75114C3.83066 15 3.08447 14.2538 3.08447 13.3333V6.66665C3.08447 5.74617 3.83066 4.99998 4.75114 4.99998L6.41781 4.99998M14.7511 15V4.99998M14.7511 15H16.4178C17.3383 15 18.0845 14.2538 18.0845 13.3333V6.66665C18.0845 5.74617 17.3383 4.99998 16.4178 4.99998H14.7511M14.7511 4.99998C14.7511 4.07951 14.0049 3.33331 13.0845 3.33331H8.08447C7.164 3.33331 6.41781 4.07951 6.41781 4.99998"
                    stroke="#5E6678"
                    stroke-width="1.25"
                  />
                </svg>
                <BaseText
                  type="body"
                  size="sm"
                  class="truncate flex-1 gantt-row-text"
                >
                  {{ ad.ad_id }}
                </BaseText>
                <div
                  class="group-hover:opacity-100 opacity-0 absolute right-0 transition-all duration-75 pr-2 bg-transparent"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                  >
                    <path
                      d="M20.23 12C20.23 13 18.48 18.25 12.98 18.25C7.47998 18.25 5.72998 13 5.72998 12C5.72998 11 7.47998 5.75 12.98 5.75C18.48 5.75 20.23 11 20.23 12Z"
                      stroke="#5E6678"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M15.23 12C15.23 13.2426 14.2226 14.25 12.98 14.25C11.7373 14.25 10.73 13.2426 10.73 12C10.73 10.7574 11.7373 9.75 12.98 9.75C14.2226 9.75 15.23 10.7574 15.23 12Z"
                      stroke="#5E6678"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </template>
          </g-gantt-row>
        </g-gantt-chart>
        <div
          class="flex flex-col gantt-timeaxis-animation overflow-y-visible ml-auto"
          style="width: calc(100% - 232px)"
        >
          <div class="flex items-center w-full justify-around pl-4">
            <div
              v-for="(item, index) in dateRange"
              :key="index"
              class="relative flex justify-end"
              :class="currentZoom === 'year' && 'h-5'"
              :style="{ width: item.widthPercentage + '%' }"
            >
              <div
                v-if="item.day === '1'"
                class="w-0.5 bg-border-normal absolute bottom-0 opacity-30 mr-0.5"
                :style="`height: ${55 * advertisements.length}px;`"
              />
              <!-- Display month (if available) -->
              <div
                v-if="item.month"
                class="absolute bottom-5"
                :class="{
                  'left-5': currentZoom === 'month',
                  'left-20 pl-5': currentZoom === 'week',
                  'left-1': currentZoom === 'year'
                }"
              >
                <div
                  v-if="currentZoom === 'year'"
                  class="w-0.5 bg-border-normal absolute bottom-0 opacity-30 "
                  :style="`height: ${55 * advertisements.length}px;`"
                />
              </div>
            </div>
          </div>
        </div>
        <AdvertisementDetailsDrawer
          v-if="showAdvertisementDetailsDrawer && !trialExpired"
          :all-ads.sync="advertisements"
          :discovery="discovery"
          :advertisement="selectedAdvertisement"
          :shared-board="sharedBoard"
          :shared-brief="sharedBrief"
          :loading="loading"
          @getMoreAds="$emit('getMoreAds')"
          @close="closeModal"
          @save="$emit('reload')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GGanttChart, GGanttRow } from 'vue-ganttastic'
import AdvertisementDetailsDrawer from './AdvertisementDetailsDrawer'
import moment from 'moment'

export default {
  name: 'AdvertisementGanttList',
  components: {
    AdvertisementDetailsDrawer,
    GGanttChart,
    GGanttRow
  },
  props: {
    // Advertisements
    advertisements: {
      type: Array,
      default: () => []
    },
    sharedBoard: {
      type: Boolean,
      default: () => false
    },
    sharedBrief: {
      type: Boolean,
      default: () => false
    },
    discovery: {
      type: Boolean,
      default: () => false
    },
    editBriefView: {
      type: Boolean,
      default: () => false
    },
    noDrawer: {
      type: Boolean,
      default: () => false
    },
    smallAds: {
      type: Boolean,
      default: () => false
    },
    myChartStart: {
      type: String,
      default: () => null
    },
    myChartEnd: {
      type: String,
      default: () => null
    },
    currentZoom: {
      type: String,
      default: () => 'month'
    }
  },
  data () {
    return {
      selectedAdvertisement: {},
      showAdvertisementDetailsDrawer: false,
      promptSignup: false,
      currentSize: 0,
      days: [],
      grabbing: false,
      dragStartX: 0,
      loading: false,
      xStart: null,
      xDiff: null,
      ganttBarElement: null,
      advertisementRightValues: []
    }
  },
  computed: {
    ...mapState('AdvertisementsModule', ['adToOpen']),
    ...mapGetters('AuthModule', ['getUserFreeTrialDate', 'isFreeTier', 'getTeam']),
    trialExpired () {
      // check if a week has passed since trial and if they're free tier
      return this.isFreeTier && Date.now() > this.getUserFreeTrialDate + 6.048e8 && !this.getTeam && !this.discovery
    },
    dateRange () {
      const startDate = moment(this.myChartStart).startOf('day')
      const endDate = moment(this.myChartEnd).endOf('day')
      const result = []
      let currentMonth = ''

      const totalDays = endDate.diff(startDate, 'days') + 1
      const widthPercentage = 100 / totalDays

      while (startDate.isSameOrBefore(endDate, 'day')) {
        if (this.currentZoom !== 'year') {
          const currentItem = {
            day: startDate.format('D'),
            widthPercentage,
            barLeftPosition: this.mapTimeToPosition(startDate),
            barWidth: this.mapTimeToPosition(startDate.clone().add(1, 'days'))
          }

          if (
            (startDate.date() === 1 ||
          startDate.isSame(startDate.clone().startOf('month'), 'day')) &&
        startDate.format('MMMM') !== currentMonth
          ) {
            currentItem.month = startDate.format(
              this.currentZoom === 'year' ? 'MMM' : 'MMMM'
            )
            currentMonth = startDate.format('MMMM')
          }

          result.push(currentItem)
        } else {
          if (
            startDate.date() === 1 &&
        startDate.format('MMMM') !== currentMonth
          ) {
            const monthDays = startDate.daysInMonth()
            const monthWidthPercentage = widthPercentage * monthDays

            const monthItem = {
              month: startDate.format('MMM'),
              widthPercentage: monthWidthPercentage,
              barLeftPosition: this.mapTimeToPosition(startDate),
              barWidth: this.mapTimeToPosition(startDate.clone().add(monthDays, 'days'))
            }

            currentMonth = startDate.format('MMMM')
            result.push(monthItem)
          }
        }
        startDate.add(1, 'day')
      }
      this.$nextTick(() => {
        this.barLabelSticky()
      })
      return result
    }
  },
  watch: {
    adToOpen (newValue) {
      const newAd =
        this.advertisements.find((a) => a.ad_id === Number(newValue.ad_id)) || {}

      if (Object.keys(newAd).length) {
        this.selectedAdvertisement = newAd
        this.showAdvertisementDetailsDrawer = true
      }
    },
    advertisements () {
      this.$nextTick(() => {
        setTimeout(() => {}, 1000)
        this.barLabelSticky()
      })
    },
    currentZoom () {
      this.$nextTick(() => {
        setTimeout(() => {}, 1000)
        this.barLabelSticky()
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.barLabelSticky()
    })
    window.addEventListener('keydown', this.handleArrowNavigation)
    const adId = this.$route.query.ad
    if (!adId) return

    const newAd = this.advertisements.find((a) => a.ad_id === Number(adId)) || {}

    if (Object.keys(newAd).length) {
      this.selectedAdvertisement = newAd
      this.showAdvertisementDetailsDrawer = true
    }
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.handleArrowNavigation)
  },
  methods: {
    ...mapMutations('AdvertisementsModule', ['SET_AD_TO_OPEN']),
    handleOpenAdvertisementDetailsDrawer (advertisement) {
      this.selectedAdvertisement = advertisement
      this.showAdvertisementDetailsDrawer = true
    },
    closeModal () {
      this.showAdvertisementDetailsDrawer = false
      this.selectedAdvertisement = {}
      this.SET_AD_TO_OPEN({})
    },
    reflowGrid () {
      this.$refs.feed.reflow()
    },
    formatAdvertisementTime (timestamp) {
      return moment(timestamp).format('YYYY-MM-DD HH:mm')
    },
    handleDragChart (event) {
      if (!this.grabbing) return
      const { clientX } = event

      // Calculate the mouse movement direction
      const mouseDeltaX = clientX - this.dragStartX
      if (mouseDeltaX < 0) {
      // Dragging to the right, so move to the next day
        this.nextDay()
      } else if (mouseDeltaX > 0) {
      // Dragging to the left, so move to the previous day
        this.previousDay()
      }

      // Update the dragStartX for the next iteration
      this.dragStartX = clientX
    },
    handleScrollChart (event) {
      const deltaX = event.deltaX

      if (deltaX > 100) {
        // Scrolling right, so move to the next day
        this.nextDay()
      } else if (deltaX < -100) {
        // Scrolling left, so move to the previous day
        this.previousDay()
      }
    },
    handleArrowNavigation (event) {
      if (event.key === 'ArrowRight') {
        this.nextDay()
      } else if (event.key === 'ArrowLeft') {
        this.previousDay()
      }
    },
    handleMouseUp (event, ad) {
      const { clientX } = event

      // Calculate the mouse movement direction
      const mouseDeltaX = clientX - this.dragStartX
      if (mouseDeltaX !== 0) {
        this.handleOpenAdvertisementDetailsDrawer(ad)
      }

      this.grabbing = false
    },
    handleMouseDown () {
      this.grabbing = true
      this.dragStartX = 0
    },
    mapTimeToPosition (time) {
      const start = moment(this.myChartStart)
      const end = moment(this.myChartEnd)

      const totalHourCount = end.diff(start, 'hours', true)

      const hourDiffFromStart = moment(time).diff(start, 'hours', true)
      const positionPercentage = (hourDiffFromStart / totalHourCount) * 100

      return positionPercentage
    },
    nextDay () {
      const today = moment().startOf('day').format('YYYY-MM-DD HH:mm')
      if (this.currentZoom === 'week') {
        let newStart = moment(this.myChartStart).add(0.5, 'days')
        let newEnd = moment(this.myChartEnd).add(0.5, 'days')
        if (moment(newEnd).isAfter(today)) {
          newStart = moment(today).subtract(1, 'week')
          newEnd = moment(today)
        }
        this.$emit('update:myChartStart', newStart.format('YYYY-MM-DD HH:mm'))
        this.$emit('update:myChartEnd', newEnd.format('YYYY-MM-DD HH:mm'))
      } else if (this.currentZoom === 'month') {
        let newStart = moment(this.myChartStart).add(2, 'days')
        let newEnd = moment(this.myChartEnd).add(2, 'days')
        if (moment(newEnd).isAfter(today)) {
          const difference = moment(newEnd).diff(moment(today), 'days')
          newStart = moment(this.myChartStart).add(2 - difference, 'days')
          newEnd = moment(today)
        }
        this.$emit('update:myChartStart', newStart.format('YYYY-MM-DD HH:mm'))
        this.$emit('update:myChartEnd', newEnd.format('YYYY-MM-DD HH:mm'))
      } else {
        let newStart = moment(this.myChartStart).add(10, 'days')
        let newEnd = moment(this.myChartEnd).add(10, 'days')
        if (moment(newEnd).isAfter(today)) {
          const difference = moment(newEnd).diff(moment(today), 'days')
          newStart = moment(this.myChartStart).add(10 - difference, 'days')
          newEnd = moment(today)
        }
        this.$emit('update:myChartStart', newStart.format('YYYY-MM-DD HH:mm'))
        this.$emit('update:myChartEnd', newEnd.format('YYYY-MM-DD HH:mm'))
      }
      this.$nextTick(() => {
        this.barLabelSticky()
      })
    },
    previousDay () {
      if (this.currentZoom === 'week') {
        const newStart = moment(this.myChartStart).subtract(0.5, 'days')
        const newEnd = moment(this.myChartEnd).subtract(0.5, 'days')
        this.$emit('update:myChartStart', newStart.format('YYYY-MM-DD HH:mm'))
        this.$emit('update:myChartEnd', newEnd.format('YYYY-MM-DD HH:mm'))
      } else if (this.currentZoom === 'month') {
        const newStart = moment(this.myChartStart).subtract(2, 'days')
        const newEnd = moment(this.myChartEnd).subtract(2, 'days')
        this.$emit('update:myChartStart', newStart.format('YYYY-MM-DD HH:mm'))
        this.$emit('update:myChartEnd', newEnd.format('YYYY-MM-DD HH:mm'))
      } else {
        const newStart = moment(this.myChartStart).subtract(10, 'days')
        const newEnd = moment(this.myChartEnd).subtract(10, 'days')
        this.$emit('update:myChartStart', newStart.format('YYYY-MM-DD HH:mm'))
        this.$emit('update:myChartEnd', newEnd.format('YYYY-MM-DD HH:mm'))
      }
      this.$nextTick(() => {
        this.barLabelSticky()
      })
    },
    barLabelSticky () {
      this.advertisementRightValues = []
      this.advertisements.forEach((ad) => {
        const label = this.$refs[`gantt-label-${ad.id}`][0].parentElement.parentElement.style
        const leftValue = parseFloat(label.left.split('px')[0])
        if (leftValue < -12) {
          this.advertisementRightValues.push(leftValue * -1)
        } else {
          this.advertisementRightValues.push('20%')
        }
      })
    },
    formatRunningDuration (start, end) {
      let endTime = end._seconds * 1000

      if (isNaN(endTime)) {
        endTime = new Date().getTime()
      }
      const startDate = moment(start)
      const endDate = moment(endTime)

      return Math.ceil(moment.duration(endDate.diff(startDate)).as('days'))
    }
  }
}
</script>

<style >
/*
  Style unscoped because of the gantt chart library styling
*/

.g-gantt-bar {
  border-radius: 0.375rem !important;
  user-select: none !important;
  top: 9px !important;
  background: transparent !important;
}

.g-gantt-row {
  height: 54px !important;
}

.g-gantt-row-label {
  width: 232px !important;
  font-family: "Inter var", "system-ui" !important;
  font-size: 14px !important;
  line-height: 20px !important;
}

.g-gantt-row-bars-container {
  width: calc(100% - 232px) !important;
  border-bottom-width: 1px !important;
  --tw-border-opacity: 1 !important;
}

.g-gantt-row>.g-gantt-row-bars-container {
  border-bottom-width: 0px !important;
  user-select: none !important;
}

.g-gantt-tooltip {
  display: none !important;
}

div.g-gantt-bar-label {
  padding: 0px !important;
}

#g-gantt-chart {
  font-family: "Inter var", "system-ui" !important;
  padding: 0px !important;
  border-bottom: 1px solid #ECEFF3 !important;
}

.gantt-row-text {
  font-family: "Inter var", "system-ui" !important;
}

</style>

<style scoped>
.green-background {
  background-image: url('../../assets/icons/gantt-bar-live.png');
  background-size: 400px 35px;
  background-position: center;
  background-repeat: repeat-x;
  opacity: 0.98;
}

.gray-background {
  background-image: url('../../assets/images/repeadable-grey.png');
  background-size: 400px 35px;
  background-position: center;
  background-repeat: repeat-x;
  opacity: 0.95;
}

.timeaxis-line--month {
  margin-bottom: 70px;
}
</style>
